
// Definición de defaults

export const defaultEstatus: EstatusProps = {
    idEstatus:      0,
    descripcion:    '',
    activo:         false,
}

// Creación de interfaces

export interface EstatusProps {
    idEstatus:         number;
    descripcion:       string;
    activo:            boolean;
}